import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Oriel',
    description: "Oriel is a humanoid robot designed for real homes. It tidies, folds, carries and fetches with care, and asks when it isn't sure.",
    url: getOrigin(),
    ogImage: 'https://oriel.cdn.modulify.website/images/og-oriel.jpg'
}
